import { AddPhotoAlternate } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import React from 'react';

const style = {
  width: 64,
  height: 64,
  emptyStateIcon: {
    borderRadius: '50%',
    sx: {
      bgColor: 'primary.main',
    },
  },
  fontSize: 25,
  imgProps: {
    style: {
      objectFit: 'contain',
    },
  },
} as const;

type Props = {
  alt: string,
  src: string,
  width?: number,
  height?: number,
}

export const CustomAvatar = ({
  alt, src, width, height,
}: Props):JSX.Element => {
  return (
    <Avatar
      alt={ alt || '' }
      sx={ { width, height } }
      imgProps={ style.imgProps }
      src={ src || '' }
    >
      <AddPhotoAlternate
        sx={ {
          color: style.emptyStateIcon.sx.bgColor,
          borderRadius: style.emptyStateIcon.borderRadius,
          fontSize: style.fontSize,
        } }
      />
    </Avatar>
  );
};

CustomAvatar.defaultProps = {
  width: 64,
  height: 64,
};
